import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { Constants } from '../../config/constants';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class IntroGuard {
  constructor(
    public storageService: StorageService,
    public router: Router
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const intro = this.storageService.getItem(Constants.SELECT_LANGUAGES);
    if (intro) {
      return true;
    } else {
      this.router.navigate(['selected-language'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }
  }
}
